import {connect} from 'react-redux';
import Step9 from './Step9';
import {submitStep} from '../../actions/submitStep';
import {uploadFile} from '../../actions/uploadFile';
import {prevCompletedStepSignFalse} from "../../actions/prevCompletedStepSign/prevCompletedStepSignFalse";

const mapStateToProps = ({
                           regType: {regType},
                           locales: {current: language},
                           stepPayload: {payload},
                           prevCompletedStepSign: {prevCompletedStepSign}
                         }) => ({
  regType,
  payload,
  language,
  prevCompletedStepSign
});

export default connect(
  mapStateToProps,
  {submitStep, uploadFile, prevCompletedStepSignFalse}
)(Step9);
